export default __webpack_public_path__ + "static/3-foundation-results-4ecf8b37fdd81853e0c0dab83a3aafec.png";